import React from "react";

const PayrollLogo = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M34 13.421c0 6.307-5.232 11.422-11.69 11.422V2c4.625 0 8.62 2.62 10.516 6.426A11.158 11.158 0 0 1 34 13.42Z"
            fill="#FFA700"
        />
        <path
            d="M4.927 2C3.312 2 2 3.281 2 4.86v26.278c0 1.58 1.312 2.86 2.927 2.86h4.14v-6.451a.994.994 0 0 1 1.006-.982h4.162a.994.994 0 0 1 1.005.982v6.45h4.14c1.619 0 2.928-1.28 2.928-2.86V2H4.928Z"
            fill="#007AFF"
        />
        <path
            d="M12.154 30.41a1.07 1.07 0 0 0 1.082-1.058 1.07 1.07 0 0 0-1.082-1.058 1.07 1.07 0 0 0-1.083 1.058 1.07 1.07 0 0 0 1.083 1.057Z"
            fill="#60B158"
        />
        <path
            d="m14.655 21.798-2.887-4.263a3.33 3.33 0 0 0-.62-.738 1.737 1.737 0 0 0-.698-.397 3.351 3.351 0 0 0-.931-.114H6.746v-1.403h3.877c1.033 0 1.81-.208 2.326-.626.517-.43.795-1.048.834-1.857l.29.19H6.746v-1.193h7.33l-.33.229c-.103-.656-.407-1.15-.912-1.478-.49-.34-1.19-.512-2.095-.512H6.746V8.444h10.818v1.192h-3.762l.33-.246c.465.24.828.555 1.085.947.26.391.42.846.484 1.364l-.389-.304h2.25v1.193h-2.189l.37-.361c.025.809-.15 1.51-.524 2.101-.362.594-.89 1.056-1.59 1.382-.685.316-1.52.473-2.502.473v-.19h.426c.53 0 .996.115 1.396.34.4.227.795.627 1.183 1.193l2.908 4.263h-2.384v.007Z"
            fill="#fff"
        />
        <path
            opacity={0.14}
            d="M32.826 8.426a7.368 7.368 0 0 1-3.259.753c-4.007 0-7.257-3.175-7.257-7.09V2c4.625 0 8.62 2.62 10.516 6.426Z"
            fill="#fff"
        />
    </svg>
);

export default PayrollLogo;